import React from "react";
import { Box } from "@mui/material";
import { dt, StatusBadgeColorConfig } from "../../themes/redesignTokens";

interface RedesignStatusBadgeProps {
  label: string;
  colorConfig: StatusBadgeColorConfig;
  size?: "sm" | "lg";
}

/** Left-bar accent status badge used across all redesigned pages. */
const RedesignStatusBadge = ({ label, colorConfig: c, size = "sm" }: RedesignStatusBadgeProps) => {
  const isLg = size === "lg";
  // L6 (USER-LANG-IT-PL-1): the ellipsis now lives on an inner span. text-overflow does not
  // apply to an inline-flex box's anonymous text item, so a long label ("Bestätigung
  // ausstehend", "Oczekuje na potwierdzenie") was hard-clipped with no "…". The title gives
  // the full label on hover. Props and outer box unchanged.
  return (
    <Box
      title={label}
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: "7px",
        backgroundColor: c.bg,
        borderLeft: `3px solid ${c.text}`,
        borderRadius: isLg ? "0 6px 6px 0" : "0 8px 8px 0",
        padding: isLg ? "4px 12px 4px 10px" : "5px 14px 5px 10px",
        fontSize: isLg ? "12px" : { xs: "11px", sm: "12px" },
        fontWeight: 600,
        fontFamily: dt.font,
        color: c.text,
        letterSpacing: "0.2px",
        whiteSpace: "nowrap",
        lineHeight: isLg ? "16px" : "18px",
        transition: "all 0.2s ease",
        maxWidth: "100%",
        overflow: "hidden",
        textOverflow: "ellipsis",
      }}
    >
      <span style={{ minWidth: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{label}</span>
    </Box>
  );
};

export default RedesignStatusBadge;
